import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Anchor } from 'wt-ui';
import { Notification } from 'grommet-icons';

import heap from '../../services/heap';
import AlertLayer from '../AlertLayer';

const AlertMe = ({ event }) => {
  const [openLayer, setOpenLayer] = useState(false);

  return (
    <>
      <Anchor onClick={() => setOpenLayer(true)}>
        <Notification size="small" />
      </Anchor>
      {openLayer ? (
        <AlertLayer
          event={event}
          onEsc={(e) => {
            e.preventDefault();
            setOpenLayer(false);
          }}
          onClickOutside={() => {
            heap.track('Calendar_ClickAlert');
            setOpenLayer(false);
          }}
        />
      ) : (
        ''
      )}
    </>
  );
};

AlertMe.propTypes = {
  event: PropTypes.shape({}).isRequired,
};

export default AlertMe;
